import {TemplateNode} from "#template/template-node/template-node"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {SwitchNodeParameters} from "#template/fundamental/switch/types"
import {fundamentalLikeMarker, type FundamentalLikeNode} from "#template/role-markers"
import type {EvaluatedValueOf} from "#template/fundamental/factory"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"

export abstract class SwitchNode<out ItemType extends FundamentalLikeNode<unknown> = FundamentalLikeNode<unknown>>
    extends TemplateNode<SwitchNodeParameters<ItemType>>
    implements FundamentalLikeNode<EvaluatedValueOf<ItemType> | null>
{
    get [fundamentalLikeMarker]() {
        return true as const
    }

    getValue(evaluator: NodeEvaluator): ItemType | null {
        const {activeNodeSet} = evaluator

        for (const src of this.parameters.nodes.parameters.list) {
            if (!activeNodeSet || activeNodeSet.has(src)) {
                return src as ItemType
            }
        }
        return null
    }

    evaluate(_scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<EvaluatedValueOf<ItemType> | null> {
        return evaluator.evaluate(this.getValue(evaluator) as ItemType | null) as BuilderInlet<EvaluatedValueOf<ItemType> | null>
    }
}
